export default {"src":"/_next/static/media/chat-outline.7afe7705.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};